export type AvailableLocale = "de" | "en";

export const config = {
    siteName: process.env.REACT_APP_SITE_NAME,
    release: process.env.REACT_APP_SITE_RELEASE,
    //apiBaseUrl: "https://localhost:7095/api",
    //apiBaseUrl: "https://localhost:56688/api",
    apiBaseUrl: "https://yndijc7adh7mggzhebmcytgh4a0qrcic.lambda-url.us-west-1.on.aws/api",
    sentry: {
        enable: process.env.REACT_APP_ENABLE_SENTRY === "true",
        dsn: process.env.REACT_APP_SENTRY_DSN,
        env: process.env.REACT_APP_SENTRY_ENV,
    },
};

export default config;
